/*

    CODE FOR DRAGGABLE MARKERS, DOESN'T WORK AT THE MOMENT AND
    MAY GOD HELP YOU IF YOU WANT TO ADD CLICK EVENTS.

*/

import React from 'react';
import {
    withStyles
} from '@material-ui/core/styles';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { MAIN_MAP } from '../../redux/map/Constants';

import * as MapboxGl from 'mapbox-gl';

class DraggableMarker extends React.Component {
    marker = null;

    constructor (props) {
        super(props);

        this.state = {

        };
    }

    componentDidMount () {
        const { drawModule, id, buttons } = this.props;
        const map = drawModule.props.map;
        this.marker = new MapboxGl.Marker({
            draggable: this.props.draggable,
            element: document.getElementById(id),
            anchor: this.props.anchor,
            style: {
                width: '300px',
                height: '225px'
            }
        })
            .setLngLat([this.props.coordinates.lng, this.props.coordinates.lat])
            .addTo(map);
        this.marker.getElement().addEventListener('click', (e) => {
            e.stopPropagation();
            for (const button of buttons) {
                if (e.target === document.getElementById(button.id) || e.target.parentElement === document.getElementById(button.id)) {
                    console.log('stopPropagation');
                    button.event();
                }
            }
        });
    }

    componentWillUnmount () {
        if (this.marker) {
            this.marker.getElement().remove();
            this.marker.remove();
            this.marker = null;
        }
    }

    render () {
        const { classes, id } = this.props;
        return <div className={classes.marker}>{this.props.children}</div>;
    }
}

const styles = (theme) => ({
    marker: {
        // pointerEvents: 'none'
    }
});

const mapStateToProps = (state) => ({
    drawModule: state[MAIN_MAP].drawModule
});

export default compose(
    withStyles(styles),
    connect(mapStateToProps)
)(DraggableMarker);